import {
  type ScratchcardOrderQuery,
  ScratchcardState,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export default defineNuxtRouteMiddleware(async (to) => {
  const client = useNuxtApp().$apollo.defaultClient
  const { navigateToLocalized } = useRouterUtils()

  const FALLBACK_ROUTE = `/my-orders/scratchcard/${to.params.id}`

  try {
    const response = await client.query<ScratchcardOrderQuery>({
      fetchPolicy: 'network-only',
      query: ScratchcardOrderDocument,
      variables: { orderId: to.params.id },
    })

    const scratchcards = response.data.scratchcardOrder.scratchcards
    const currentScratchcard = scratchcards.find(
      ({ serialNumber }) => serialNumber === to.params.serialNumber,
    )

    if (!currentScratchcard || currentScratchcard.status !== ScratchcardState.Scratched) {
      return navigateToLocalized({ path: FALLBACK_ROUTE, replace: true })
    }
  } catch {
    return navigateToLocalized({ path: FALLBACK_ROUTE, replace: true })
  }
})
